'use client';

import { initAPM } from '@shared/utils/apm';
import pkg from '../../package.json';

initAPM({
  serviceName: pkg.name,
  sessionReplayRecording: process.env.NEXT_PUBLIC_APP_ENV === 'production',
  version: pkg.version,
  env: process.env.NEXT_PUBLIC_APP_ENV as string,
});
